import { gql } from "@apollo/client";
export const BulkUpdateWorkItems= gql`
mutation BulkUpdateWorkItems(
    $request: BulkUpdatePayload!
  ) {
    BulkUpdateWorkItems(request: $request) 
  }
`;
